import React, { useState } from 'react';
import { FiPlay } from 'react-icons/fi';
import media, { trainingSessions } from '../../data/media';

function TrainingSessionCard({ item }) {
  return (
    <article className="tt-media-card tt-training-card">
      <div className="tt-media-thumb">
        <img src={item.image} alt={item.alt || item.title} loading="lazy" />
      </div>
      <div className="tt-media-meta">
        <span>{item.venue} · <strong>{item.topic}</strong></span>
        <span>{item.badge}</span>
      </div>
      <h3>{item.title}</h3>
    </article>
  );
}

function MediaCard({ item }) {
  const [playing, setPlaying] = useState(false);

  return (
    <article className="tt-media-card">
      <div className="tt-media-thumb">
        {playing ? (
          <iframe
            src={`https://www.youtube-nocookie.com/embed/${item.id}?autoplay=1&rel=0`}
            title={item.title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        ) : (
          <button type="button" onClick={() => setPlaying(true)} aria-label={`Play video: ${item.title}`}>
            <img src={`https://i.ytimg.com/vi/${item.id}/hqdefault.jpg`} alt="" loading="lazy" />
            <span className="tt-media-play" aria-hidden="true"><FiPlay /></span>
          </button>
        )}
      </div>
      <div className="tt-media-meta">
        <span>{item.date} · <strong>{item.topic}</strong></span>
        <span>{item.duration}</span>
      </div>
      <h3>
        <a href={`https://www.youtube.com/watch?v=${item.id}`} target="_blank" rel="noopener noreferrer">{item.title}</a>
      </h3>
      <p>{item.takeaway}</p>
      <a className="tt-media-link" href={`https://www.youtube.com/watch?v=${item.id}`} target="_blank" rel="noopener noreferrer">
        <FiPlay aria-hidden="true" /> Watch on {item.platform}
      </a>
    </article>
  );
}

export default function MediaLibrary({ track = 'teach', featuredOnly = true }) {
  if (track === 'teach') {
    const sessions = trainingSessions.filter((item) => item.visible);
    return (
      <div className="tt-media-grid">
        {sessions.map((item) => <TrainingSessionCard item={item} key={item.id} />)}
      </div>
    );
  }

  const items = media.filter((item) => item.visible && (!featuredOnly || item.featured));
  return (
    <div className="tt-media-grid">
      {items.map((item) => <MediaCard item={item} key={item.id} />)}
    </div>
  );
}
